// action.ts
export const CHANGE_PROGRES = 'CHANGE_PROGRES';

export interface ChangeProgresAction {
  type: typeof CHANGE_PROGRES;
  payload: number; // Assuming the payload is the new module name
}

export const changeProgress = (newProgres: number): ChangeProgresAction => ({
  type: CHANGE_PROGRES,
  payload: newProgres,
});

// progresAction.ts
// progresAction.ts
// export const CHANGE_PROGRES = 'CHANGE_PROGRES';

// export interface ChangeProgresAction {
//   type: typeof CHANGE_PROGRES;
//   payload: {
//     journeyId: any;
//     progress: any;
//   };
// }

// export const changeProgress = (journeyId: any, newProgress: any): ChangeProgresAction => ({
//   type: CHANGE_PROGRES,
//   payload: { journeyId, progress: newProgress },
// });

